// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
main .policies_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 90%;
  margin: 0 auto;
  min-height: 70vh;
}
main .policies_main h1 {
  text-transform: uppercase;
  text-decoration: underline;
}
main .policies_main .agree__box {
  border: 1px solid #bf1a1a;
  padding: 2%;
}
main .policies_main h6 {
  align-self: flex-start;
  margin: 0 auto 0 0;
  font-size: 1rem;
}
main .policies_main p {
  align-self: flex-start;
}
main .sigCanvas {
  border: 1px solid #1d1d1d;
  width: 60%;
  height: 15vh;
}
main .clear_btn {
  margin: 2% auto;
}
@media (max-width: 690px) {
  main {
    margin: 2% auto;
  }
  main .policies_main h1, main .policies_main h2, main .policies_main h3 {
    text-align: center;
  }
  main .sigCanvas {
    width: 90%;
    height: 18vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/policies.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAGA;EC8BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AD/BJ;AAAI;EC4BA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED7BI,UAAA;EACA,cAAA;EACA,gBAAA;AAKR;AAJQ;EACI,yBAAA;EACA,0BAAA;AAMZ;AAJQ;EACI,yBAAA;EACA,WAAA;AAMZ;AAJQ;EACI,sBAAA;EACA,kBAAA;EACA,eAAA;AAMZ;AAJQ;EACI,sBAAA;AAMZ;AAHI;EACI,yBAAA;EACA,UAAA;EACA,YAAA;AAKR;AAHI;EACI,eAAA;AAKR;AAHI;EAhCJ;IAiCQ,eAAA;EAMN;EAJU;IACI,kBAAA;EAMd;EAHM;IACI,UAAA;IACA,YAAA;EAKV;AACF","sourcesContent":["@import './variables.scss';\n\n\nmain{\n    @include columnStartCenter;\n    .policies_main{\n        @include columnStartCenter;\n        width: 90%;\n        margin: 0 auto;\n        min-height: 70vh;\n        h1{\n            text-transform: uppercase;\n            text-decoration: underline;\n        }\n        .agree__box{\n            border: 1px solid $rtRed;\n            padding: 2%;\n        }\n        h6{\n            align-self: flex-start;\n            margin: 0 auto 0 0;\n            font-size: 1rem;\n        }\n        p{\n            align-self: flex-start;  \n        }\n    }\n    .sigCanvas{\n        border: 1px solid $rtBlack;\n        width: 60%;\n        height: 15vh;\n    }\n    .clear_btn{\n        margin: 2% auto;\n    }\n    @media(max-width: $mobile){\n        margin: 2% auto;\n        .policies_main{\n            h1, h2, h3{\n                text-align: center;\n            }\n        }\n        .sigCanvas{\n            width: 90%;\n            height: 18vh;\n        }    \n    }\n}","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
